import styled from "@emotion/styled";
import Head from "next/head";
import React from "react";
import CoverSection from "@components-pages/formulario-prestamos/cover-section";
import FormSection from "@components-pages/formulario-prestamos/form-section";
import BgWrapperSection from "@components/bg-wrapper-section";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { GetStaticPropsContext } from "next";
import { TitleThickThin } from "@components/titles";
import { useTranslations } from "next-intl";

import type { NextPage } from "next";
import { Grid, Typography } from "@mui/material";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import LoanFormRHF from "@components-pages/formulario-prestamos/form-section/loan-form-rhf";
import WsPhantomNav from "@components/a1-refactor/typography/WsPhantomNav";
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const Prestamos: NextPage = () => {
  const translation = useTranslations("mortgageForm.form");
  const titleT = useTranslations("title-pages");
  const titles = translation("title") || "";
  const title_light = translation("title_light") || "";
  const metaData: IHeadMetaComponent = {
    description: "loadForm",
    title: "loansForm",
    og_type: "page-prestamos-hipotecarios",
    url: "/prestamos/formulario",
  };
  return (
    <>
      <HeadMeta {...metaData} />
      <Head>
        <title>{titleT("loansForm")}</title>
        <meta name="description" content="" />
      </Head>
      <WsPhantomNav />

      <ContentForm container>
        <Grid item xs={12}>
          <CoverSection />
        </Grid>

        <Grid container item xs={12} alignItems={"center"} justifyContent={"center"} paddingY={8} px={4} gap={4}>
          <WsSectionTitleWithThinTitle title={titles} subtitle={title_light} />
          <FormSection />
        </Grid>
      </ContentForm>
    </>
  );
};

export default Prestamos;

const ContentForm = styled(Grid)`
  background-color: var(--color-brand-cream-primary);
`;

const ContentWithBorder = styled.div`
  background-color: red;
`;
